import React from 'react'
import Layout from '../components/Layout/Layout'
import RefundPolicyComponent from '../components/RefundPolicyComponent'

const RefundPolicy = () => {
  return (
    <>
     <Layout>
        <RefundPolicyComponent />
     </Layout>
    </>
  )
}

export default RefundPolicy